import type { FC } from 'react';

import { useLinkComponent } from '@eneco/link';
import { Box, Card, Image, Heading, TextLink, Stack } from '@eneco/sparky';

import type { PagesByTags } from '../types';


export const Article: FC<PagesByTags['articles'][0]> = ({ url, fields: { image, title, pagelinktext } }) => {
  const Link = useLinkComponent();
  return (
    <Card overflow="hidden">
      <Image
        src={`${image.src}?width=${image.width}&height=${image.height}`}
        alt={image.alt}
        hasLazyLoad={false}
        width="100%"
        aspectRatio="16/9"
        objectFit="cover"
      />
      <Box padding="6">
        <Stack gap="6">
          <Heading as="h3" size="S">
            {title}
          </Heading>
          <Link href={url} linkType="internal">
            <TextLink emphasis="high">{pagelinktext}</TextLink>
          </Link>
        </Stack>
      </Box>
    </Card>
  );
};
